import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGlobe, faChevronDown, faCheck } from "@fortawesome/free-solid-svg-icons";

function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const [selectedLanguage, setSelectedLanguage] = useState('en');

  const [dropdownOpen, setDropdownOpen] = useState(false);

  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };

  const changeLanguage = (lng) => {
    setDropdownOpen(false);
    i18n.changeLanguage(lng);
    setSelectedLanguage(lng);
    document.documentElement.setAttribute("dir", lng === "ar" ? "rtl" : "ltr");
  };

  useEffect(() => {
    setSelectedLanguage(i18n.language);
    document.documentElement.setAttribute(
      "dir",
      i18n.language === "ar" ? "rtl" : "ltr"
    );
  }, [i18n.language]);

  const currentCode = i18n.language === "ar" ? "AR" : "EN";

  return (
    <div className="language-switcher">
      <button
        type="button"
        className={`lang-trigger ${dropdownOpen ? "open" : ""}`}
        onClick={toggleDropdown}
        aria-haspopup="listbox"
        aria-expanded={dropdownOpen}
        aria-label="Change language"
      >
        <FontAwesomeIcon icon={faGlobe} className="lang-globe" />
        <span className="lang-code">{currentCode}</span>
        <FontAwesomeIcon icon={faChevronDown} className="lang-caret" />
      </button>
      {dropdownOpen && (
        <div className="dropdown-menu" role="listbox">
          <button
            role="option"
            aria-selected={i18n.language === "en"}
            className={i18n.language === "en" ? "selected" : ""}
            onClick={() => changeLanguage("en")}
          >
            <span>English</span>
            {i18n.language === "en" && (
              <FontAwesomeIcon icon={faCheck} className="lang-check" />
            )}
          </button>
          <button
            role="option"
            aria-selected={i18n.language === "ar"}
            className={i18n.language === "ar" ? "selected" : ""}
            onClick={() => changeLanguage("ar")}
          >
            <span>Arabic</span>
            {i18n.language === "ar" && (
              <FontAwesomeIcon icon={faCheck} className="lang-check" />
            )}
          </button>
        </div>
      )}
    </div>
  );
}

export default LanguageSwitcher;
